<template>
  <div id="app">
    <van-loading size="24px" vertical v-if="this.showLoad"
      >加载中...</van-loading
    >
    <router-view />
    <!-- 图片预览功能 -->
    <van-image-preview
      v-model="swiperShow"
      :images="showImgs"
      :startPosition="swipercliclIndex"
      :closeable="true"
      @close="changeClose"
      class="VanImgs"
    ></van-image-preview>
  </div>
</template>

<script>
// "vant": "^2.2.16",
/* eslint-disable */
import { mapState, mapMutations } from "vuex";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";

export default {
  name: "App",
  data() {
    return {
      showImgs: [], // 展示的img
      swiperShow: false,
      swipercliclIndex: 0,
      clientType: getDeviceType(), //手机类型
    };
  },
  mounted() {
    let hashName = document.location.hash.substr(2);
    let indexOfIndex = hashName.indexOf("?");

    let routerName =
      indexOfIndex > 0 ? hashName.substr(0, indexOfIndex) : hashName;

    if (routerName != "wechat" || routerName != "dhShare") {
      this.initUserInfo();
    }
  },
  methods: {
    ...mapMutations(["setUserInfo", "setShowLoad"]),
    initUserInfo() {
      let _this = this;
      _this.$api.userCenter.user.myInfo
        .userMsg()
        .then((res) => {
          if (res.code == "1") {
            _this.setUserInfo(res.data);
          } else {
            if (res.code == "11001") {
              //token失效时
              if (_this.clientType == "android") {
                //安卓
                window.android.getInfo(106);
              } else {
                //IOS
                window.webkit.messageHandlers.closePage.postMessage("1");
              }
            } else {
              if (_this.clientType == "android") {
                //安卓
                window.android.getInfo(103);
              } else {
                //IOS
                window.webkit.messageHandlers.closePage.postMessage("2");
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeClose() {
      let name = this.$route.path;
      console.log(name);
      if (name == "/shareDetail") {
        if (this.clientType == "android") {
          window.android.getInfo(108);
        } else {
          //IOS
          window.webkit.messageHandlers.getCommentBox.postMessage(null);
        }
      }
    },
  },
  computed: {
    ...mapState(["showDataImgs", "showLoad"]),
  },
  watch: {
    showDataImgs: {
      handler: function () {
        this.showImgs = this.showDataImgs.showImgs;
        this.swipercliclIndex = this.showDataImgs.swipercliclIndex;
        this.swiperShow = this.showDataImgs.swiperShow;
      },
      deep: true,
    },
  },
};
</script>

<style lang="less">
html,
body {
  height: 100%;
}
#app {
  width: 100%;
  height: 100%;
  .VanImgs {
    .van-image-preview__image {
      width: 100%;
      max-height: 80%;
      margin-top: 20%;
    }
    .van-image-preview__close-icon {
      color: #fff;
    }
  }
}
</style>